import { IGame } from '../../../../../../api/types/game'
import React from 'react'
import { IItem } from '../../../../../../api/types/item'
import { Tooltip } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { ICreateChatMessage } from '../../../../../../api/types/chat'
import { mutationCreateChatMessage } from '../../../../../../api/mutations'
import { useGlobalError } from '../../../../../../context/GlobalError'
import TryIcon from '@mui/icons-material/Try'
import { ActionIconButton } from '../../../../../../components/ActionIconButton/ActionIconButton'
import { GiveItemModal } from '../GiveItemModal/GiveItemModal'
import { useAuth } from '../../../../../../context/Auth'

interface Props {
  item: IItem
  game: IGame
}

export const GmGameItemActions: React.FC<Props> = ({ item, game }) => {
  const auth = useAuth()
  const { addError } = useGlobalError()
  const { mutate: postChatMessage, isLoading: isPostingToChat } = useMutation(
    (newMessage: ICreateChatMessage) => mutationCreateChatMessage(newMessage),
    {
      onError: (err: any) => {
        addError('Nie udało się wysłać wiadomości', err?.status)
      },
    }
  )

  const handlePostItemToChat = () => {
    postChatMessage({
      game: game.id,
      message: `/item$${item.id}`,
    })
  }

  return (
    <>
      {auth?.gm && (
        <>
          <ActionIconButton disabled={isPostingToChat} onClick={handlePostItemToChat}>
            <Tooltip title="Wyślij na chat">
              <TryIcon />
            </Tooltip>
          </ActionIconButton>
          <GiveItemModal item={item} game={game} />
        </>
      )}
    </>
  )
}
